import Vue from 'vue';

import './sass/framework.scss';

import components from './components';
import filters from './filters';
import plugins from './plugins';

export default {
  installInVueInstance() {
    Object.keys(components).forEach((componentName) => {
      Vue.component(componentName, components[componentName]);
    });

    Object.keys(filters).forEach((filterName) => {
      Vue.filter(filterName, filters[filterName]);
    });

    plugins.forEach((plugin) => {
      Vue.use(plugin);
    });
  },
};
